import { render, staticRenderFns } from "./History.vue?vue&type=template&id=2b92fd36&scoped=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92fd36",
  null
  
)

export default component.exports